import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery } from '@lacedltd/laced-components'
import { statusToColorMap } from './PasswordCondition.styles'
import type { PasswordConditionStatus } from './PasswordCondition'

export const Container = styled.div({
  color: tokens.color.airJordan[600],
  position: 'relative',
  margin: `${tokens.spacing[3]} 0 ${tokens.spacing[6]}`
})

export const Grid = styled.div({
  [mediaQuery.m.min]: {
    gap: tokens.spacing[3]
  }
})

export const InstructionLabel = styled.p<{ status: PasswordConditionStatus }>(
  ({ status }) => ({
    color: statusToColorMap[status]
  }),
  {
    textAlign: 'left',
    margin: `0 0 ${tokens.spacing[3]}`
  }
)
